import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import colorStyle from './colorChoice.module.scss';

function ColorChoice(props) {
  const {
    colors, width, itemWidth, onChange, clearAll, colorNameSize,
  } = props;
  const [checkedList, setCheckedList] = useState([]);

  useEffect(() => {
    if (clearAll) {
      setCheckedList([]);
    }
  }, [clearAll]);

  const onClickItem = (item) => {
    const index = checkedList.indexOf(item);
    if (index > -1) {
      checkedList.splice(index, 1);
      onChange([...checkedList]);
      setCheckedList([...checkedList]);
    } else {
      onChange([...checkedList, item]);
      setCheckedList([...checkedList, item]);
    }
  };
  // onClearChecked
  const isLightColor = (color) => color === '#fff' || color === '#ffffff' || color === 'white';
  return (
    <div className={colorStyle['colors-choice']} style={{ width: `${width}` }}>
      {
        colors.map((item) => (
          <div
            className={colorStyle['colors-item']}
            key={item.id}
          >
            <span
              aria-hidden
              className={`
              ${colorStyle['colors-item-radius']} ${isLightColor(item.code) ? colorStyle['light-color'] : ''}`}
              style={{ backgroundColor: `${item.code}`, width: `${itemWidth}`, height: `${itemWidth}` }}
              onClick={() => onClickItem(item.text)}
            >
              {checkedList.includes(item.text)
                ? (
                  <>
                    <span
                      className={colorStyle['white-check']}
                      style={{ display: isLightColor(item.code) ? 'none' : '' }}
                    />
                    <span
                      className={colorStyle['black-check']}
                      style={{ display: isLightColor(item.code) ? '' : 'none' }}
                    />
                  </>
                ) : null}
            </span>
            <span className={colorStyle['color-name']} style={{ fontSize: colorNameSize }}>{item.text}</span>
          </div>
        ))
      }
    </div>
  );
}

ColorChoice.propTypes = {
  colors: PropTypes.arrayOf([PropTypes.object]).isRequired,
  width: PropTypes.string.isRequired,
  itemWidth: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  clearAll: PropTypes.bool.isRequired,
  colorNameSize: PropTypes.string,
};

ColorChoice.defaultProps = {
  colorNameSize: '14px',
};

export default ColorChoice;
